import React from 'react';
import type { Control } from 'react-hook-form';
import { Tooltip } from 'react-tooltip';

import { ReactComponent as AttachFilesIcon } from '@assets/svg/ic-attach.svg';

import { MODAL_NAMES } from '@constants/modalRenderers';

import useTranslation from '@hooks/useTranslation';

import { useModalActions } from '@store/useModalStore';

import style from './style.module.scss';
import type { IFile } from '@model/file';

interface IFormValues {
  comment: string;
  attachments: IFile[];
}

interface IProps {
  name: string;
  control: Control<IFormValues>;
  typeOfFiles?: string;
}

const AttachFiles = ({ name, control, typeOfFiles }: IProps) => {
  const { t } = useTranslation();

  const { setSecondaryModal } = useModalActions();

  return (
    <div id="attach-block">
      <div
        className={style.attachBlockBtn}
        onClick={() =>
          setSecondaryModal({ name: MODAL_NAMES.attachFilesModal, options: { name, control, typeOfFiles } })
        }
      >
        <AttachFilesIcon />
      </div>
      <Tooltip anchorSelect="#attach-block" content={t('Add files')} />
    </div>
  );
};

export default AttachFiles;
